import React from 'react';
import { motion } from 'framer-motion';
import './PrizesSection.css';

const PrizesV1Section = () => {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        delayChildren: 0.3,
        staggerChildren: 0.2
      }
    }
  };

  const cardVariants = {
    hidden: { y: 50, opacity: 0, scale: 0.9 },
    visible: {
      y: 0,
      opacity: 1,
      scale: 1,
      transition: {
        duration: 0.8,
        ease: "easeOut"
      }
    }
  };

  return (
    <div className="prizes-v1-content">
      <motion.div className="prizes-announcement" variants={cardVariants}>
        <div className="announcement-card">
          <div className="announcement-icon">💰</div>
          <div className="announcement-content">
            <h3>مجموع جوائز 15,000+ ₪!</h3>
            <p>تنافس على جوائز مذهلة وتقدير بينما تصنع تأثيراً إيجابياً على المجتمع!</p>
          </div>
        </div>
      </motion.div>
      
      <motion.div className="prizes-announcement" variants={cardVariants}>
        <div className="first-place-circular">
          <div className="circular-content">
            <div className="circular-icon">🥇</div>
            <div className="circular-title">المركز الأول</div>
            <div className="circular-amount">7,000+ ₪</div>
          </div>
          <div className="circular-glow"></div>
        </div>
      </motion.div>
    </div>
  );
};

export default PrizesV1Section;
